import React from "react";
import { Grid, Cell } from "react-md";
import { QAMacCard } from "components/User/Mac";
import { connect } from "react-redux";
import PropTypes from "prop-types";


const QAMac = (
  {
    internetUserId
  }
) => {
  return (
    <Grid className="case-header mac-page no-padding">
      <Cell size={12}>
        <QAMacCard 
          internetUserId={internetUserId}
        />
      </Cell>
    </Grid>
  );
};

QAMac.propTypes = {
  internetUserId: PropTypes.number,
};

const mapStateToProps = state => {
  return {
    internetUserId: state.user.profile.internetUserId,
  };
};

export default connect(mapStateToProps)(QAMac);